import Vue from 'vue'

// Vuesax Component Framework
import './plugins/vuesax.js'

// Attach prototype helpers
import './plugins/helpers/index.js'

// axios with api base path
import api from './api/index.js'
Vue.prototype.$api = api

// axios with global accessibility
import http from './plugins/http.js'
Vue.prototype.$http = http

// directives
import './plugins/directives.js'

// Globally Registered Components
import './plugins/globalComponents.js'

// Styles: SCSS & CSS
import './assets/scss/main.scss'
import './assets/css/main.css'

// Tailwind
import '@/assets/css/tailwind.css'

// Vuex Store
import { initializer, store } from './store/index.js'

// Vue Router
import router from './store/router/config/router'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

import VCalendar from 'v-calendar'
Vue.use(VCalendar)

// Custom text filters
import './plugins/filters'

// Validation and additional global rules
import Validation from './plugins/validation'
Vue.use(Validation)

// Custom mixins
import mixins from './plugins/mixins'

// Feather font icon
require('./assets/css/iconfont.css')

import App from './App.vue'
Vue.config.productionTip = false

initializer()
    .then(() => {
        Vue.mixin(mixins)

        new Vue({
            router,
            store,
            render: (h) => h(App)
        }).$mount('#app')
    })
    .catch((error) => {
        console.error(`FATAL ERROR: ${error}`)
    })
